import React, { Component } from 'react';
import { Form, FormGroup, ControlLabel } from 'react-bootstrap'
import Input from 'rc-input-number'
import './InputNumber.css'
class InputNumber extends Component {

    constructor(...args) {
      super(...args)
      this.state = {}
      
    }

    onFormChange(e) {
        this.props.onChange(e)
    }

    render() {
        let {formData,schema,required,uiSchema} = this.props
        let textAlign = 'right'
        if (typeof uiSchema.textAlign!=='undefined')
            textAlign = uiSchema.textAlign
        return(
            <Form>
                <FormGroup>
                    <ControlLabel>{schema.title}{required?<span className='text-red'>*</span>:''}</ControlLabel>
                    <Input
                        className={'input-number-format text-'+textAlign}
                        value={formData} 
                        onChange={this.onFormChange.bind(this)}
                        formatter={value =>
                            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                        }
                    /> 
                </FormGroup>
            </Form>        
        )
    }    
}    
export default InputNumber


// WEBPACK FOOTER //
// ./src/component/element/InputNumber.js